import React from "react";
import { Link } from "react-router-dom";

const Banner = () => {
	return (
		<div className="container py-5">
			<div className="row d-flex align-items-center">
				<div className="col-md-6">
					<div className="d-flex mb-4">
						<div className="bg-black py-1 px-2 fw-bolder rounded text-white me-2">
							JavaScript
						</div>
						<div className="bg-black py-1 px-2 fw-bolder  rounded text-white mx-2">
							Python
						</div>
						<div className="bg-black py-1 px-2 fw-bolder  rounded text-white mx-2">
							React
						</div>
						<div className="bg-black py-1 px-2 fw-bolder  rounded text-white mx-2">
							Django
						</div>
					</div>
					<h1 className="fs-1 fw-bolder text-uppercase">Want to become a Web Developer?</h1>
					<p className="mb-4">
						Discover our course, follow this and make your web world more
						attractive. We have collected the best Web Course Instructor for
						your dream web
					</p>
					<Link to="/courses">
						<button className="btn bg-dark text-white fw-bolder px-5 py-3">
							Join With Us
						</button>
					</Link>
				</div>
				<div className="col-md-6">
					<img src="banner.png" className="img-fluid" alt="" />
				</div>
			</div>
		</div>
	);
};

export default Banner;
